module.exports = __webpack_public_path__ + "img/taking.5497fae8.gif";